module.exports = __webpack_public_path__ + "img/intelligentService-5.6f570c6c.png";